import Aos from 'aos';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick'
import { toast } from 'react-toastify';

const Home = () => {

    const [isSticky, setIsSticky] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ "quote[name]": "", "quote[phone]": "", "quote[email]": "", "quote[message]": "" });

    var testi_slider = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
                slidesToScroll: 1
            }
        }
        ]
    }

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const openPopup = (e) => {
        if (e) e.preventDefault();
        setShowPopup(true);
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowPopup(true);
        }, 15000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        Aos.init();
    }, []);


    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const validateForm = () => {
        const { "quote[name]": name, "quote[phone]": phone, "quote[email]": email } =
            formData;

        if (!name.trim() || !phone.trim() || !email.trim()) {
            toast.error("Please fill out all required fields!");
            return false;
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            toast.error("Please enter a valid email address!");
            return false;
        }
        if (phone.length < 7) {
            toast.error("Please enter a valid phone number!");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        const data = new URLSearchParams({
            ...formData,
            "quote[lead_url]": window.location.href,
        });
        setLoading(true);
        try {
            const response = await axios.post(
                "https://chapterspresspublishers.com/lp/christian-book/sendmail.php",
                data,
                {
                    headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                }
            );
            if (response.data.status === 1) {
                toast.success("Message sent successfully! Redirecting...");
                setFormData({ "quote[name]": "", "quote[phone]": "", "quote[email]": "", "quote[message]": "", });
                setShowPopup(false);
                setTimeout(() => {
                    window.location.href =
                        "https://chapterspresspublishers.com/thankyou";
                }, 1000);
            } else {
                toast.error("Something went wrong! Please try again.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to send message!");
        } finally {
            setLoading(false);
        }
    };

    const handleTop = (e) => {
        e.preventDefault();
        const section = document.querySelector('.packages_sec');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    return (
        <>
            <header className={`main-header ${isSticky ? "sticky" : ""}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <Link to className="logo_here">
                                <img src="images/logo.png" alt="img" />
                            </Link>
                        </div>
                    </div>
                </div>
            </header>
            <section className="banner">
                <img src="images//banner.webp" alt />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 data-aos="fade-up" data-aos-duration="1000">Publish Your Christian Book <br />with Faith and Excellence</h1>
                            <p data-aos="fade-up" data-aos-duration="2000">We help authors share their testimonies, devotionals, and faith-based <br />
                                stories with the world — from manuscript to ministry</p>
                            <ul className="btns_wrp" data-aos="fade-up" data-aos-duration="3000">
                                <li><Link to="#" className="btn1" onClick={openPopup}>Get a Free <br />Manuscript Review</Link></li>
                                <li><Link to="#" className="btn2" onClick={handleTop}>View Publishing <br />Packages</Link></li>
                            </ul>
                            <div className="banner_btm">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="banner_btm_wrp">
                                            <span><img src="images//icons/1.png" alt /></span>
                                            <p>Faith-Based Editors</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="banner_btm_wrp">
                                            <span><img src="images//icons/2.png" alt /></span>
                                            <p>Global Christian Distribution</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="banner_btm_wrp">
                                            <span><img src="images//icons/3.png" alt /></span>
                                            <p>100% Author Royalties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="message_deserves_sec">
                <img src="images//d-vec1.png" alt className="d-vec1" />
                <img src="images//d-vec2.png" alt className="d-vec2" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <ul className="social_icons" data-aos="fade-up" data-aos-duration="1000">
                                <li><Link to><i className="fa-brands fa-facebook-f" /></Link></li>
                                <li><Link to><i className="fa-brands fa-twitter" /></Link></li>
                                <li><Link to="tel:+4242672767"><i className="fa-solid fa-phone" /></Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="message_deserves_img" data-aos="fade-right" data-aos-duration="1500">
                                <img src="images//dersve_img.webp" alt />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="message_deserves_textt" data-aos="fade-left" data-aos-duration="1500">
                                <h2>Your Message Deserves More
                                    Than Just a Publisher</h2>
                                <ul>
                                    <li>
                                        <img src="images//icons/d1.png" alt />
                                    </li>
                                    <li>
                                        <h3>Faith-Sensitive Editing </h3>
                                        <p>Editors who understand Scripture tone
                                            and theological integrity</p>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <img src="images//icons/d2.png" alt />
                                    </li>
                                    <li>
                                        <h3>Ministry-Minded Design </h3>
                                        <p>Covers and interiors that reflect
                                            reverence and clarity</p>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <img src="images//icons/d3.png" alt />
                                    </li>
                                    <li>
                                        <h3>Global Christian Reach </h3>
                                        <p>Distribution across Amazon, Ingram,
                                            and Christian bookstores</p>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <img src="images//icons/d4.png" alt />
                                    </li>
                                    <li>
                                        <h3>Mission-Aligned Marketing</h3>
                                        <p>PR focused on church readers, faith media
                                            and devotionals</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="step_process_secc">
                <img src="images//process_bg1.png" alt className="process_bg1" />
                <img src="images//process_bg2.png" alt className="process_bg2" />
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <h2 data-aos="fade-up" data-aos-duration="1000">Step-by-Step Process</h2>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr" data-aos="fade-up" data-aos-duration="0">
                                <span>
                                    <img src="images//icons/p1.png" alt />
                                </span>
                                <h3>Free Editorial Review</h3>
                                <p>Understand your manuscript and audience.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr" data-aos="fade-up" data-aos-duration="500">
                                <span>
                                    <img src="images//icons/p2.png" alt />
                                </span>
                                <h3>Editing &amp; Proofreading</h3>
                                <p>Faith-based editors refine and polish.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr" data-aos="fade-up" data-aos-duration="1000">
                                <span>
                                    <img src="images//icons/p3.png" alt />
                                </span>
                                <h3>Cover &amp; Interior Design</h3>
                                <p>Clean, reverent, visually aligned.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr rght_bx" data-aos="fade-up" data-aos-duration="1500">
                                <span>
                                    <img src="images//icons/p4.png" alt />
                                </span>
                                <h3>Publishing Setup</h3>
                                <p>ISBN, KDP, IngramSpark, metadata.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr" data-aos="fade-up" data-aos-duration="2000">
                                <span>
                                    <img src="images//icons/p5.png" alt />
                                </span>
                                <h3>Distribution</h3>
                                <p>Global reach, Christian bookstores included.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr" data-aos="fade-up" data-aos-duration="2500">
                                <span>
                                    <img src="images//icons/p6.png" alt />
                                </span>
                                <h3>Launch Support</h3>
                                <p>Author pages, social teasers, and ARCs</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="process_wrpr rght_bx" data-aos="fade-up" data-aos-duration="3000">
                                <span>
                                    <img src="images//icons/p7.png" alt />
                                </span>
                                <h3>Ongoing Support</h3>
                                <p>Royalty monitoring and reprints.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="packages_sec">
                <img src="images//pkvec1.webp" alt className="pkvec1" />
                <img src="images//pkvec2.png" alt className="pkvec2" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 data-aos="fade-up" data-aos-duration="1000">Our Packages</h2>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="package_box" data-aos="flip-left" data-aos-duration="1000">
                                <div className="package_head">
                                    <img src="images//icons/pk1.png" alt />
                                    <span>$ 1,500</span>
                                </div>
                                <h3>Starter <br />Faith Plan</h3>
                                <ul>
                                    <li><i className="fa-solid fa-check"></i> Editorial Care – Copyediting & proofreading by Christian-aware editors.</li>
                                    <li><i className="fa-solid fa-check"></i> Interior Formatting – Professionally typeset for Kindle & print with scripture styling.</li>
                                    <li><i className="fa-solid fa-check"></i> Basic Cover Design – One creative concept with 2 revision rounds.</li>
                                    <li><i className="fa-solid fa-check"></i> ISBN & Barcode – Assigned under your author name.</li>
                                    <li><i className="fa-solid fa-check"></i> KDP Setup – Complete Kindle & paperback setup.</li>
                                    <li><i className="fa-solid fa-check"></i> Author Central Setup – Amazon author profile creation.</li>
                                    <li><i className="fa-solid fa-check"></i> Free Editorial Review – Pre-publishing quality check.</li>
                                    <li><strong>Timeline:</strong> 3–4 weeks from final manuscript submission.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="package_box" data-aos="fade-up" data-aos-duration="1000">
                                <div className="package_head">
                                    <img src="images//icons/pk2.png" alt />
                                    <span>$ 3,000</span>
                                </div>
                                <h3>Standard <br />Ministry Plan</h3>
                                <ul>
                                    <li><i className="fa-solid fa-check"></i> Everything in Starter Faith Plan, plus:</li>
                                    <li><i className="fa-solid fa-check"></i> Substantive Editing – Chapter structure & message alignment.</li>
                                    <li><i className="fa-solid fa-check"></i> Premium Cover Design – 2 design concepts, unlimited minor revisions.</li>
                                    <li><i className="fa-solid fa-check"></i> Hardcover, Paperback & eBook Layouts.</li>
                                    <li><i className="fa-solid fa-check"></i> Dual Platform Distribution – KDP + IngramSpark setup.</li>
                                    <li><i className="fa-solid fa-check"></i> Retail Metadata Optimization – Christian keywords & pricing guidance.</li>
                                    <li><i className="fa-solid fa-check"></i> Back-Cover Copywriting – Engaging Christian-focused blurb.</li>
                                    <li><i className="fa-solid fa-check"></i> Free Proof Copy Review – Test copy before release.</li>
                                    <li><strong>Timeline:</strong> 4–6 weeks from final manuscript submission.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="package_box" data-aos="flip-right" data-aos-duration="1000">
                                <div className="package_head">
                                    <img src="images//icons/pk3.png" alt />
                                    <span>$ 4,500</span>
                                </div>
                                <h3>Kingdom <br />Reach Plan</h3>
                                <ul>
                                    <li><i className="fa-solid fa-check"></i> Everything in Standard Ministry Plan, plus:</li>
                                    <li><i className="fa-solid fa-check"></i> Theology & Sensitivity Read – Doctrinal & respectful tone review.</li>
                                    <li><i className="fa-solid fa-check"></i> Endorsement & ARC Outreach Kit – For pastors & Christian media.</li>
                                    <li><i className="fa-solid fa-check"></i> 15 Social Launch Assets – Ready-to-post visuals & captions.</li>
                                    <li><i className="fa-solid fa-check"></i> Basic Amazon Ads Setup – Keyword-based discoverability boost.</li>
                                    <li><i className="fa-solid fa-check"></i> Press Release Distribution – Sent to Christian media outlets.</li>
                                    <li><i className="fa-solid fa-check"></i> Launch Consultation – 1-on-1 strategy session.</li>
                                    <li><i className="fa-solid fa-check"></i> Church / Small-Group Pack Guide – Ministry bundle support.</li>
                                    <li><strong>Timeline:</strong> 6–8 weeks (expedited options available).</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <section className="what_clients_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 data-aos="fade-up" data-aos-duration="1000">What Clients Say</h2>
                        </div>
                    </div>
                </div>
                <div className="testi_wrpr">
                    <img src="images//testi_bg.png" alt />
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="testi_slider" data-aos="fade-up" data-aos-duration="2000">
                                    <Slider {...testi_slider}>
                                        <div>
                                            <div className="testi_box">
                                                <div className="testii_textt">
                                                    <h3>Emily Grace</h3>
                                                    <span>Author of <em>Faithful Horizons</em></span>
                                                    <p>
                                                        Amelia Williams was incredibly helpful from the very start. The team was attentive,
                                                        and they really made my vision a reality. I’m proud to be part of such a great team
                                                        of Christian publishers.
                                                    </p>
                                                    <ul>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                    </ul>
                                                </div>
                                                <div className="testii_imgg">
                                                    <img src="images/testito.jpg" alt="Emily Grace" />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="testi_box">
                                                <div className="testii_textt">
                                                    <h3>Pastor John Matthews</h3>
                                                    <span>Author of <em>Grace in the Everyday</em></span>
                                                    <p>
                                                        I’ve worked with several publishers, but none have provided the level of support and
                                                        professionalism I received here. This is by far the best Christian publishing service
                                                        in the market.
                                                    </p>
                                                    <ul>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                    </ul>
                                                </div>
                                                <div className="testii_imgg">
                                                    <img src="images//testi_img.png" alt="Pastor John Matthews" />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="testi_box">
                                                <div className="testii_textt">
                                                    <h3>Sarah Thompson</h3>
                                                    <span>Author of <em>Seeds of Hope</em></span>
                                                    <p>
                                                        The entire process was made so easy. Amelia and the team were with me every step of the way,
                                                        ensuring everything was perfect. I’m so grateful for their expertise.
                                                    </p>
                                                    <ul>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                    </ul>
                                                </div>
                                                <div className="testii_imgg">
                                                    <img src="images//testi_img3.jfif" alt="Sarah Thompson" />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="testi_box">
                                                <div className="testii_textt">
                                                    <h3>Michael Harris</h3>
                                                    <span>Author of <em>Walking by Faith</em></span>
                                                    <p>
                                                        I couldn’t have asked for a better publishing partner. Chapters Press Publishers made
                                                        the process seamless, and I’m thrilled with the final product. Truly the best Christian
                                                        publishers out there.
                                                    </p>
                                                    <ul>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                        <li><i className="fa-solid fa-star" /></li>
                                                    </ul>
                                                </div>
                                                <div className="testii_imgg">
                                                    <img src="images//testi_img4.jpg" alt="Michael Harris" />
                                                </div>
                                            </div>
                                        </div>
                                    </Slider>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="genres_publish_secc">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 data-aos="fade-up" data-aos-duration="1000">Genres We Publish</h2>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="genres_box" data-aos="fade-left" data-aos-duration="1500">
                                <img src="images//icons/g1.png" alt />
                                <h3>Testimonies &amp; <br />Memoirs</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="genres_box" data-aos="fade-down" data-aos-duration="1500">
                                <img src="images//icons/g2.png" alt />
                                <h3>Christian <br />Living</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="genres_box" data-aos="fade-right" data-aos-duration="1500">
                                <img src="images//icons/g3.png" alt />
                                <h3>Bible Studies</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="genres_box" data-aos="fade-left" data-aos-duration="1500">
                                <img src="images//icons/g4.png" alt />
                                <h3>Devotionals</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="genres_box" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images//icons/g5.png" alt />
                                <h3>Children’s <br />Faith Books</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="genres_box" data-aos="fade-right" data-aos-duration="1500">
                                <img src="images//icons/g6.png" alt />
                                <h3>Poetry &amp; <br />Reflections</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="signup_secc">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <img src="images//signup.webp" alt />
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="signup_form">
                            <h2 data-aos="fade-up" data-aos-duration="1000">Sign up to get free consultation</h2>
                            <form onSubmit={handleSubmit} data-aos="fade-up" data-aos-duration="1500">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <input
                                            type="text"
                                            name="quote[name]"
                                            placeholder="Full Name*"
                                            value={formData["quote[name]"]}
                                            onChange={handleChange}
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <input
                                            type="number"
                                            name="quote[phone]"
                                            placeholder="Phone*"
                                            value={formData["quote[phone]"]}
                                            onChange={handleChange}
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <input
                                            type="email"
                                            name="quote[email]"
                                            placeholder="Email"
                                            value={formData["quote[email]"]}
                                            onChange={handleChange}
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <textarea
                                            name="quote[message]"
                                            placeholder="Message"
                                            value={formData["quote[message]"]}
                                            onChange={handleChange}
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <button type="submit" disabled={loading}>
                                            {loading ? "Submiting..." : "Submit"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="cta_secc">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 data-aos="fade-up" data-aos-duration="1000">Let Your Words <br />Inspire Faith.</h2>
                            <p data-aos="fade-up" data-aos-duration="1500">Share your Christian message with the world we ‘ll guide you every step of the way.</p>
                            <Link to="#" className="btn1 popup_open" onClick={openPopup} data-aos="fade-up" data-aos-duration="2000">Get Free Manuscript <br />Review</Link>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <div className="footer_top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <img src="images///logo.png" alt="" />
                                <p>Empowering authors to publish with purpose.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_middle">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="footer_links">
                                    <h4>Quick Links</h4>
                                    <ul>
                                        <li><Link to>About</Link></li>
                                        <li><Link to>Packages</Link></li>
                                        <li><Link to>Blog</Link></li>
                                        <li><Link to>Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="footer_links">
                                    <h4>Contact</h4>
                                    <ul>
                                        <li>
                                            <Link to="mailto:info@chapterspresspublishers.com">info@chapterspresspublishers.com</Link>
                                        </li>
                                        <li><Link to="tel:+4242672767">(424) 267-2767</Link></li>
                                        <li><Link to>Mailing Address : 12100 Wilshire Boulevard 8th Floor, Los Angeles, CA, 90025, USA</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="footer_social">
                                    <ul>
                                        <li><Link to><i className="fa-brands fa-facebook-f" /></Link></li>
                                        <li><Link to><i className="fa-brands fa-instagram" /></Link></li>
                                        <li><Link to><i className="fa-brands fa-linkedin-in" /></Link></li>
                                    </ul>
                                    <p>2025 Chapters Press Publishers.
                                        All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <Link to="tel:+4242672767" className="nmbr onlymob"><i className="fa-solid fa-phone-flip" /></Link>
            {showPopup && (
                <>
                    <div className="overlay show_overlay" onClick={closePopup}></div>
                    <div className="popup_form show_popup" onClick={(e) => e.stopPropagation()}>
                        <button className="popup_close" onClick={closePopup}>
                            &times;
                        </button>
                        <img src="images//popup-vec.png" alt />
                        <h2>Sign up to get free consultation</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <input
                                        type="text"
                                        name="quote[name]"
                                        placeholder="Full Name*"
                                        value={formData["quote[name]"]}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <input
                                        type="number"
                                        name="quote[phone]"
                                        placeholder="Phone*"
                                        value={formData["quote[phone]"]}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <input
                                        type="email"
                                        name="quote[email]"
                                        placeholder="Email"
                                        value={formData["quote[email]"]}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <textarea
                                        name="quote[message]"
                                        placeholder="Message"
                                        value={formData["quote[message]"]}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit" disabled={loading}>
                                        {loading ? "Submiting..." : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
            )}
        </>
    )
}

export default Home